// OrderReceiptNode.js
import React from 'react';
import { Handle, Position } from 'reactflow';
import orderReceiptIcon from './orderReceiptIcon.svg';

const OrderReceiptNode = ({ data }) => {
  return (
    <div
      style={{
        padding: '10px',
        border: '5px solid #ddd',
        borderRadius: '25px',
        backgroundColor: '#fff',
        width: '105px',
        height: '105px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <img
        src={orderReceiptIcon}
        alt="Confirmation"
        style={{ width: '50%', height: '50%' }}
      />
      <Handle
        type="target"
        position={Position.Left}
        style={{ borderRadius: 0 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ borderRadius: 0 }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-30px',
          width: '100%',
          textAlign: 'center',
          fontSize: '18px',
          whiteSpace: 'nowrap',
        }}
      >
        Order Receipt
      </div>
    </div>
  );
};

export default OrderReceiptNode;
